import { createApp } from 'vue'
import ReceiptContent from './ReceiptContent'

const el = '.kb-component--receipt-content'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((ReceiptContentDOM) => {
            document.body.classList.add('kb-receipt-page')
            const receiptResults = ReceiptContentDOM.dataset.receiptResults
                ? JSON.parse(ReceiptContentDOM.dataset.receiptResults)
                : {}
            const component = createApp(ReceiptContent, { receiptResults }).use(
                Store
            )
            component.mount(ReceiptContentDOM)
        })
    }
}
